import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  return (
    <React.Fragment>
      <SEO title="Venue | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Venue"
        content="For Participants"
        contentTwo="Venue"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>

        <div className="entry-content">
          <h3>Venue</h3>
          <br></br>
          <div className="info">
          Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
          <br></br>
          <br></br>
          Note: Presentations should be in English.
          </div>
          <div className="space-60"></div>

          <h3>How to participate online</h3>
        <br></br>
            <div className="crucial2">
            The ICSI Organizing Committee decided to use Tencent Conference as the software for online conference.
            Countries and regions other than China can use VooV Meeting to participate. Room numbers for meetings are listed below.
            <br></br>
            
            </div>

<br></br>
            <table>
            <thead>
  <tr>
    <th > Room Name</th>
    <th > Room Code </th>
    <th > Agenda </th>
    <th > Time</th>
  </tr>
  <tr>
    <td>Main Venue</td>
    <td> 813-8813-1998   </td>
    <td>Conference Infomation Desk 
      <br></br>Opening Ceremony and Speeches
      <br></br>Awards Ceremony
       </td>
    <td>
      14:00-17:00, July 15th <br></br>
      09:30-13:40, July 16th <br></br>
      17:30-18:00, July 17th
       </td>

       {/* <br></br>Opening Ceremony and Speeches on July 16th 09:30-13:40, <br></br>Awards Ceremony on July 17th 17:30-18:00  */}
  </tr>
  <tr>
    <td>Online Room 1</td>
    <td>468-1096-7189  </td>
    <td>  Parallel Session 1 </td>
    <td rowSpan={3}  > <br></br>13:40 - 17:20 , July 16th 
    <br></br> 08:40 - 17:20 , July 17th  </td>
  </tr>
  <tr>
    <td> Online Room 2</td>
    <td> 	538-849-544  </td>
    <td>  Parallel Session 2  </td>
  </tr>
  <tr>
    <td>  Online Room 3</td>
    <td>  488-336-374  </td>
    <td>  Parallel Session 3 </td>
  </tr>
</thead>
            </table>

        <h3>How to Submit video</h3>
      <br></br>
          <div className="info">
          The ICSI&apos;2022 conference supports the submission of speech videos to participate in the conference. If your speech time conflicts with your schedule, you can submit a 15-minute video, which will be played by the conference team. 
          <br></br>
          The recorded video needs to be uploaded to the network disk and submitted to the conference team in the form of a link. It is recommended to use Alibaba Cloud or Baidu Cloud. And It is recommended to use onedrive in countries and regions other than China. The video needs to be submitted to the conference team two days in advance.
          <br></br>
          <br></br>
          Please note: Authors submitting videos need to participate in the opening ceremony and award ceremony of the conference. 
          </div>

        </div>
        {/* <UnderConstruction/> */}
        {/* <div className="entry-content">
          <p>&nbsp;</p>
          <h5>
          The venue for 2022 International Conference on Swarm Intelligence (ICSI) is to be announced.
          </h5>
          <p>&nbsp;</p>
          <h4>About the venue hotel</h4>
          Blue Horizon Hotel (Qingdao Shilaoren International Exhibition Center
          store) is affiliated to Shandong Blue Horizon Hotel Group, located in
          Laoshan District, Qingdao City, and shilao tourist resort in the
          south. It is an important part of Shandong International Conference
          and Exhibition Center. The rooms are distributed on the 3rd to 9th
          floors, with spacious and bright rooms, equipped with complete
          equipment such as broadband network, satellite TV, international
          direct dial telephone, small bar, electronic safe, etc., and equipped
          with transparent toilet and modern home facilities, showing luxury and
          fashion. It is an ideal choice for you to stay in business and life.
          <p>&nbsp;</p>
          <h4>About the university</h4>
          Ocean University of China (OUC) is a comprehensive university with
          particular strengths in oceanography and fisheries science. We have
          four campuses – Yushan, Fushan, Laoshan and Huangdao, which is
          currently under construction – all of which are united under our motto
          “Ocean embraces all streams; exploring promises reaching far.” OUC was
          one of the first universities approved to confer undergraduate and
          postgraduate degrees by the State Academic Degree Committee and it now
          offers courses in science, engineering, agronomy (fisheries),
          pharmaceutics, economics, management, liberal arts, law, education,
          history, and art. In 2017 it was included in China’s plan of building
          &quot;Double First-Rate&quot; universities, having previously also
          been on the list of &quot;Project 985&quot; universities (a list of
          China’s top 40 universities) and &quot;Project 211&quot; institutions
          (of China’s top 100 universities). It is now the recipient of
          significant national and provincial support and funding, which
          supports its bid to become a world class university.
          <p>&nbsp;</p>
          <h4>Location</h4>
          Address: No. 9-2, Miaoling Road, Laoshan District, Qingdao, China.
          Please refer to the{" "}
          <a href="https://goo.gl/maps/99Co7WDgMxujiNZM8">Google</a> or{" "}
          <a href="https://j.map.baidu.com/c5/tYK">Baidu</a> map to find the
          exact location of the conference venue.
          <p>&nbsp;</p>
          <div className="row">
            <iframe
              src="https://map.baidu.com/poi/%E9%9D%92%E5%B2%9B%E8%93%9D%E6%B5%B7%E5%A4%A7%E9%A5%AD%E5%BA%97(%E5%B4%82%E5%B1%B1%E5%BA%97)/@13411516,4290391,17z?uid=341c35de82aa8ca7e6073875&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl"
              width={900}
              height={600}
              loading="lazy"
            ></iframe>
          </div>
          <p>&nbsp;</p>
        </div> */}
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Venue;
